import { BORROWER_MODEL_KEYS as BMK } from "../loan/BORROWER_MODEL_KEYS";
import { LOAN_MODEL_KEYS as LMT } from "../loan/LOAN_MODEL_KEYS";
import { LOAN_RELATED_CONTACT_MODEL_KEYS as LCK } from "../loan/LOAN_RELATED_CONTACT_MODEL_KEYS";
import { SUBJECT_PROPERTY_MODEL_KEYS as SPK } from "../loan/SUBJECT_PROPERTY_MODEL_KEYS";

export const loanQuickAppFormKeys = {
  //##### LOAN LEVEL #####\\
  // - EXISTING FIELDS
  loanPurpose: LMT.loanPurpose,
  loanProductType: LMT.loanProductType,

  // - NEW FIELDS NOT YET ADDED TO OFFICIAL MODEL
  hasClosedWithLenderBefore: LMT.hasClosedWithLenderBefore, // boolean
  isBrokeredLoan: LMT.isBrokeredLoan, // boolean
  loanRelatedContacts: [
    {
      loanRole: "Broker Contact",
      firstName: LCK.firstName, // string
      lastName: LCK.lastName, // string
      phone: LCK.phone, // string
      emailAddress: LCK.emailAddress, // string
      company: LCK.company, // string
    },
  ],
  //##### PROPERTY LEVEL #####\\
  subjectProperties: [
    {
      // - EXISTING FIELDS
      address: SPK.address,
      purchasePrice: SPK.purchasePrice,
      asIsValue: SPK.asIsValue,
      constructionBudget: SPK.constructionBudget,
      propertyType: SPK.propertyType,
      purchaseDate: SPK.purchaseDate,
      totalMonthlyRent: SPK.totalMonthlyRent,
      annualTaxes: SPK.annualTaxes,
      annualInsurance: SPK.annualInsurance,
      annualHoaFees: SPK.annualHoaFees,
      arv: SPK.arv,
      additionalBasis: SPK.additionalBasis, // dollar
      expectedClosingDate: SPK.expectedClosingDate, // date

      // - NEW FIELDS NOT YET ADDED TO OFFICIAL MODEL
      hasSqftAddedOrUseChanged: SPK.hasSqftAddedOrUseChanged, // boolean
      hasApprovedPlansAndPermits: SPK.hasApprovedPlansAndPermits, // boolean
      refinanceType: SPK.refinanceType, // select || ["Cash Out", "Rate and Term"]
      requestedLoanTermMonths: SPK.requestedLoanTermMonths, // select || ["6 months", "12 months", "18 months", "24 months"]
    },
  ],

  //##### BORROWER LEVEL #####\\
  borrowers: [
    {
      // - EXISTING FIELDS
      firstName: BMK.firstName,
      lastName: BMK.lastName,
      emailAddress: BMK.emailAddress,
      phone: BMK.phone,
      company: BMK.company,
      cashLiquidity: BMK.cashLiquidity,
      referralSource: BMK.referralSource,
      estimatedFICO: BMK.estimatedFICO,

      // - NEW FIELDS NOT YET ADDED TO OFFICIAL MODEL
      smsOptIn: BMK.smsOptIn, // boolean
      additionalLoanDetails: BMK.additionalLoanDetails, // string
      similar_projects_last_3_years: BMK.similar_projects_last_3_years, // number
    },
  ],

  //##### BORROWER LEVEL #####\\
};
